/**
 * Temporary SSOT for employee-specific overrides that are NOT yet stored
 * in the database schema (or where DB values are incorrect pending migration).
 *
 * Precedence: DB column (when set) > override > default.
 * Once the DB is correct, remove the corresponding override entries.
 */

export interface EmployeeOverride {
  /** Months where the employee had unpaid leave, as "YYYY-MM" strings. */
  unpaidLeaveMonths?: string[];
  /** Average monthly hours target — prorated by working days per month. */
  monthlyTargetHours?: number;
  /** Correct employment start date (ISO "YYYY-MM-DD") if DB value is wrong. */
  employmentStartDate?: string;
  /** Employment end date (ISO "YYYY-MM-DD") — prorates the leaving month's Soll/working days. */
  employmentEndDate?: string;
  /** Annual vacation entitlement in hours. */
  vacationHoursPerYear?: number;
  /**
   * One-time net salary adjustments per month, as "YYYY-MM" → CHF amount.
   * Added on top of the regular target_net_amount from the DB override.
   */
  monthlyNetAdjustments?: Record<string, number>;
}

const OVERRIDES: Record<string, EmployeeOverride> = {
  "dekyi@walia-solutions.ch": {
    unpaidLeaveMonths: ["2025-10"],
    monthlyTargetHours: 20,
    employmentStartDate: "2025-07-01",
    employmentEndDate: "2026-05-15", // Left mid-month — May Soll/working days prorated to the 15th
    vacationHoursPerYear: 20,
    monthlyNetAdjustments: {
      "2026-03": 50, // Insurance balance correction from previous months
      "2026-05": -534.65, // Final settlement (leaving 15.05.2026): net 185.35 instead of 720
    },
  },
};

/** Look up non-DB overrides by lowercase email. Returns empty defaults if none. */
export function getEmployeeOverride(email: string): EmployeeOverride {
  return OVERRIDES[email.toLowerCase()] ?? {};
}
